"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachYoutubePlayer = attachYoutubePlayer;
const YTvideo = {
    progress25: false,
    progress50: false,
    progress75: false,
    progress100: false,
    videoContainer: '',
    heroVideoPlayer: {},
};
function attachYoutubePlayer(videoContainerEl, height, width, videoId, analyticsService, youtubeApi, cookieHost) {
    const tag = document.createElement('script');
    YTvideo.videoContainer = videoContainerEl;
    tag.src = youtubeApi;
    tag.onload = function () {
        const checkYT = setInterval(() => {
            if (window.YT) {
                videoContainerEl.classList.add('video-active');
                loadVideo(videoContainerEl, videoId, height, width, analyticsService, cookieHost);
                clearInterval(checkYT);
            }
        }, 999);
    };
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag === null || firstScriptTag === void 0 ? void 0 : firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    return true;
}
function loadVideo(videoContainer, vid, frameheight, frameWidth, analyticsService, cookieHost) {
    const videoPlayerOptions = {
        height: frameheight || 600,
        width: frameWidth,
        videoId: vid,
        host: cookieHost,
        playerVars: {
            autoplay: 1,
            enablejsapi: 1,
            origin: window.location.origin,
            widget_referrer: window.location.origin,
        },
        events: {
            onReady: event => onPlayerReady(event, analyticsService),
            onStateChange: () => onPlayerStateChange(analyticsService),
        },
    };
    if (window.YT.player) {
        YTvideo.heroVideoPlayer = new window.YT.Player(videoContainer.querySelector('.video_iframe'), videoPlayerOptions);
    }
    else {
        window.onYouTubeIframeAPIReady = () => {
            YTvideo.heroVideoPlayer = new window.YT.Player(videoContainer.querySelector('.video_iframe'), videoPlayerOptions);
        };
        window.onYouTubeIframeAPIReady();
    }
}
function onPlayerReady(event, analyticsService) {
    event.target.playVideo();
    const videoId = typeof YTvideo.heroVideoPlayer.getVideoData !== 'undefined' ? YTvideo.heroVideoPlayer.getVideoData().video_id : '';
    const videoName = typeof YTvideo.heroVideoPlayer.getVideoData !== 'undefined' ? YTvideo.heroVideoPlayer.getVideoData().title : '';
    const videoPlayProgressTimer = setInterval(() => {
        if (YTvideo.heroVideoPlayer.getPlayerState() !== window.YT.PlayerState.PAUSED) {
            const timePercentComplete = Math.round((YTvideo.heroVideoPlayer.getCurrentTime() / YTvideo.heroVideoPlayer.getDuration()) * 100);
            const videoData = { videoId, videoName };
            videoIntervals(timePercentComplete, videoData, videoPlayProgressTimer, analyticsService);
        }
    }, 500);
}
function videoIntervals(timePercentComplete, videoData, videoPlayProgressTimer, analyticsService) {
    const { videoId } = videoData;
    const { videoName } = videoData;
    if (timePercentComplete > 24 && !YTvideo.progress25) {
        YTvideo.progress25 = true;
        analyticsService && analyticsService.registerEvent('event52', { video_name: videoName, video_id: videoId });
    }
    if (timePercentComplete > 49 && !YTvideo.progress50) {
        YTvideo.progress50 = true;
        analyticsService && analyticsService.registerEvent('event53', { video_name: videoName, video_id: videoId, player: 'Youtube' });
    }
    if (timePercentComplete > 74 && !YTvideo.progress75) {
        YTvideo.progress75 = true;
        analyticsService && analyticsService.registerEvent('event54', { video_name: videoName, video_id: videoId });
    }
    if (timePercentComplete === 100 && !YTvideo.progress100) {
        YTvideo.progress100 = true;
        clearInterval(videoPlayProgressTimer);
    }
}
function onPlayerStateChange(analyticsService) {
    const videoId = typeof YTvideo.heroVideoPlayer.getVideoData !== 'undefined' ? YTvideo.heroVideoPlayer.getVideoData().video_id : '';
    const videoName = typeof YTvideo.heroVideoPlayer.getVideoData !== 'undefined' ? YTvideo.heroVideoPlayer.getVideoData().title : '';
    if (YTvideo.heroVideoPlayer.getPlayerState() === 1) {
        analyticsService && analyticsService.registerEvent('event41', { video_name: videoName, video_id: videoId, player: 'Youtube' });
    }
    else if (YTvideo.heroVideoPlayer.getPlayerState() === 0) {
        analyticsService && analyticsService.registerEvent('event42', { video_name: videoName, video_id: videoId, player: 'Youtube' });
        YTvideo.videoContainer.classList.remove('video-active');
        YTvideo.heroVideoPlayer.destroy();
    }
}
